import React from 'react';

const AddPageIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#p96ddihoka)">
        <path
          d="M6.5 23.75h9.07c.348.46.825.871 1.309 1.223-.121.015-.25.027-.379.027h-10C5.12 25 4 23.879 4 22.5v-15A2.5 2.5 0 0 1 6.5 5h6.098c.496 0 .976.198 1.328.55l4.523 4.524c.352.352.551.832.551 1.328v1.356a6.82 6.82 0 0 0-1.25.492v-.75h-4.375a1.875 1.875 0 0 1-1.875-1.875V6.25h-5c-.69 0-1.25.56-1.25 1.25v15c0 .691.56 1.25 1.25 1.25zm11.066-12.79L13.04 6.434a.607.607 0 0 0-.289-.164v4.356c0 .344.281.625.625.625h4.355a.598.598 0 0 0-.164-.29zm3.934 7.755h1.875c.344 0 .625.316.625.625a.605.605 0 0 1-.625.625H21.5v1.875a.605.605 0 0 1-.625.625.605.605 0 0 1-.625-.625v-1.875h-1.875a.605.605 0 0 1-.625-.625c0-.309.281-.625.625-.625h1.875V16.84c0-.309.281-.625.625-.625s.625.316.625.625v1.875zm5 .66A5.626 5.626 0 0 1 20.875 25a5.626 5.626 0 0 1-5.625-5.625 5.626 5.626 0 0 1 5.625-5.625 5.626 5.626 0 0 1 5.625 5.625zM20.875 15a4.373 4.373 0 0 0-4.375 4.375 4.373 4.373 0 0 0 4.375 4.375 4.373 4.373 0 0 0 4.375-4.375A4.373 4.373 0 0 0 20.875 15z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="p96ddihoka">
          <path fill="#fff" transform="translate(4 5)" d="M0 0h22.5v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddPageIcon;
